import { InputAdornment, styled, TextField } from "@mui/material";

const NumberInput = ({
  label,
  required,
  value,
  onChange,
  startAdornment,
  endAdornment,
  width,
  placeholder,
  disabled,
}) => {
  const handleChangeNumber = e => {
    const onlyNumbers = e?.target?.value?.replace(/\D/g, "");
    onChange(onlyNumbers);
  };
  return (
    <CustomTextField
      size="small"
      fullWidth
      value={value ? value : ""}
      onChange={handleChangeNumber}
      customWidth={width}
      placeholder={placeholder || "0"}
      disabled={disabled}
      label={label}
      required={required}
      InputProps={{
        startAdornment: startAdornment && (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ),
        endAdornment: endAdornment && (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
        inputMode: "number",
      }}
    />
  );
};

const CustomTextField = styled(TextField)(({ customWidth }) => ({
  width: customWidth,
  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "&[type=number]": {
    "-moz-appearance": "textfield",
  },
}));
export default NumberInput;
